import { render, staticRenderFns } from "./SubsectionEdit.vue?vue&type=template&id=c48953a0&"
import script from "./SubsectionEdit.vue?vue&type=script&lang=js&"
export * from "./SubsectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports